import { useState } from 'react';

import CheckboxLabel from '../CheckboxLabel/CheckboxLabel';

import classes from './Checkboxes.module.scss';

const Checkboxes = ({ className, options, values, onChangeKeys, error, validated }) => {
  const [selectedKeys, setSelectedKeys] = useState(new Set(values));

  const containerClasses = [classes.container];
  className && containerClasses.push(className);

  const clickHandler = (key, checked) => {
    setSelectedKeys(prevSelectedKeys => {
      const auxKeys = new Set(prevSelectedKeys);
      checked && auxKeys.add(key);
      !checked && auxKeys.delete(key);
      onChangeKeys([...auxKeys]);
      return auxKeys;
    });
  };

  return (
    <div className={containerClasses.join(' ')}>
      {options.map(({ key, label, showCheckbox }) => (
        <CheckboxLabel
          key={key}
          error={error}
          showCheckbox={showCheckbox}
          id={key}
          checked={selectedKeys.has(key)}
          label={label}
          onClick={checked => clickHandler(key, checked)}
        />
      ))}
    </div>
  );
};

export default Checkboxes;
